import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

const MagazineListItemWrapper = styled.div<{ theme: Theme }>`
  margin: 0 0 24px 0;
  position: relative;
  transition: all 0.35s;

  .title {
    color: ${getColor('textPrimary')};
    display: flex;
    flex-direction: column;
    font-family: ${font.saolText};
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    text-decoration: none;
    margin: 8px 0 0;
    padding: 6px 4px 0;
    min-height: 80px;

    @media (${breakpoint.mdMin}) {
      margin: 8px 16px 0 0;
    }
  }

`;

export default MagazineListItemWrapper;
